module.exports = __webpack_public_path__ + "static/media/4.37c8cc66.jpg";